import React from 'react';
import PropTypes from 'prop-types';
import Image from 'components/Models/Image/Image';
import cn from 'classnames';
import './InvestorLogo.scss';

const InvestorLogo = ({ className, url, image, imageClass }) => {
    const RootTag = url ? 'a' : 'div';

    const rootTagProps = {
        ...(url && {
            href: url,
        }),
        className: cn('investor-logo', className),
    };

    return (
        <RootTag {...rootTagProps}>
            {image && (
                <img
                    alt={image.altText ? image.altText : ''}
                    className={cn('investor-logo__image', imageClass)} 
                    src={image.url}
                />
            )}
        </RootTag>
    );
};

InvestorLogo.propTypes = {
    className: PropTypes.string,
    imageClass: PropTypes.string,
    url: PropTypes.string,
    image: PropTypes.shape(Image.propTypes),
};

export default InvestorLogo;



// WEBPACK FOOTER //
// ./src/components/InvestorLogo/InvestorLogo.jsx